"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.PeriodModel = exports.PERIOD = void 0;
const core_1 = require("@veeam/core");
var PERIOD;
(function (PERIOD) {
    PERIOD["day"] = "day";
    PERIOD["week"] = "week";
    PERIOD["month"] = "month";
    PERIOD["year"] = "year";
})(PERIOD = exports.PERIOD || (exports.PERIOD = {}));
class PeriodModel extends core_1.Model {
    constructor() {
        super({
            id: PERIOD.day,
        });
    }
}
exports.PeriodModel = PeriodModel;
//# sourceMappingURL=PeriodModel.js.map